module.exports = __webpack_public_path__ + "img/1.67391a3e.png";